import * as React from 'react';
import { useGetList, LinearProgress, useGetOne } from 'react-admin';
import SMeter from '../SMeter';
import { profileStatuses } from '../../resources/UserProfile';

const TradeUnionProfileCount = ({ style = {}, tradeUnionId }) => {
	const {
		data: profileRecordData, isError: isProfileError, isLoading: isProfileLoading,
	} = useGetList(
		'UserProfile',
		{
			pagination: { page: 1, perPage: 5000 },
			sort: { field: 'updatedAt', order: 'DESC' },
			filter: { tradeUnion: { id: tradeUnionId } },
		},
	);

	const { data: tradeUnionRecordData, isTUError, isTULoading } = useGetOne(
		'TradeUnion',
		{
			id: tradeUnionId,
		},
	);

	if (!isProfileLoading && isProfileError) { return 'error'; }
	if (isProfileLoading) { return <LinearProgress />; }
	if (!profileRecordData) { return 'no user profile data'; }

	if ((!isProfileLoading && isProfileError) || (!isTULoading && isTUError)) { return 'error'; }
	if (isProfileLoading || isTULoading) { return <LinearProgress />; }
	if (!profileRecordData) { return 'no user profile data'; }
	if (!tradeUnionRecordData) { return 'no trade union data'; }

	const profileAggregatedData = profileRecordData.reduce(
		(a, { profileStatus }) => {
			return a.set(profileStatus, a.has(profileStatus) ? a.get(profileStatus) + 1 : 1);
		},
		new Map(),
	);
	const array = Array.from(profileAggregatedData.entries())
		.sort(([, k1], [, k2]) => (k1 - k2));
	const values = array.map((v) => v[1]);
	const labels = array
		.map((v) => profileStatuses.find((s) => s.id === v[0]))
		.map((v) => (v?.name) || 'не указан');

	return (
		<SMeter
			data={values}
			labels={labels}
			style={style}
			title={`Пользователи ${tradeUnionRecordData.shortTitle}`}
		/>
	);
};

export default TradeUnionProfileCount;
